import { useState } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import { HiChevronDown } from "react-icons/hi";


export function DateRangeFilter({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const ranges = [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "bi-annually", label: "Bi-Annually" },
    { value: "annually", label: "Annually" },
  ];

  const currentLabel =
    ranges.find((r) => r.value === value)?.label || "Monthly";

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 shadow-sm transition-colors"
      >
        <FaRegCalendarAlt size={16} className="text-[#6B7280]" />
        <span className="text-[#1A1A1A]">{currentLabel}</span>
        <HiChevronDown size={16} className="text-[#6B7280]" />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20">
            {ranges.map((range) => (
              <button
                key={range.value}
                onClick={() => {
                  onChange(range.value);
                  setIsOpen(false);
                }}
                className={`w-full px-4 py-2 text-left hover:bg-gray-50 transition-colors ${
                  value === range.value
                    ? "bg-[#F8F9FC] text-[#1E61DC]"
                    : "text-[#1A1A1A]"
                }`}
              >
                {range.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
